import moment from "moment";

const lastSelectableLodgingDay = moment().add(16, "months");
export default lastSelectableLodgingDay;



// WEBPACK FOOTER //
// ./assets/shared/constants/lastSelectableLodgingDay.js